import React, { FC, useCallback, useEffect, useState } from "react";

import {
    Input,
    LoadingSpinner,
    OnboardingAside,
    OnboardingContent,
    PlacesAutocomplete,
    PrimaryAlternateControl,
    // SmartDropdown,
    URLInput,
} from "@xapp/components";

// import { TEMPLATES } from "constants/templates";

import { OnboardingProps } from "../../models";

export interface AdvancedSearchStepProps {
    /**
     * Optional aside content
     */
    aside?: React.ReactNode;

    loading?: boolean;

    onboarding: OnboardingProps;

    onNext(props: OnboardingProps): void;
}

export const AdvancedSearchStep: FC<AdvancedSearchStepProps> = (props) => {
    const { aside, onboarding, loading, onNext } = props;

    const [createProps, setCreateProps] = useState<OnboardingProps>(onboarding);

    useEffect(() => {
        if (onboarding) {
            setCreateProps(onboarding);
        }
    }, [onboarding]);

    const handleBusinessNameChange = useCallback(
        (name) => {
            setCreateProps({
                ...createProps,
                name,
            });
        },
        [setCreateProps, createProps]
    );

    const handleCityStateSelect = useCallback(
        (placeId: string, description: string) => {
            // description has what we want,
            // it will be in the form "City, State, Country"
            // we want just the "City, State" part
            const searchAddress = description.split(", ").slice(0, 2).join(", ");

            setCreateProps({
                ...createProps,
                searchAddress,
            });
        },
        [setCreateProps, createProps]
    );

    const handleCityStateChange = useCallback(
        (searchAddress: string) => {
            setCreateProps({
                ...createProps,
                searchAddress,
            });
        },
        [createProps]
    );

    /*
    const handleTemplateChange = useCallback(
        (template) => {
            setCreateProps({
                ...createProps,
                template,
            });
        },
        [setCreateProps, createProps]
    ); */

    const handleNext = useCallback(() => {
        onNext(createProps);
    }, [onNext, createProps]);

    const canSearch = createProps.name && createProps.searchAddress;

    return (
        <>
            {aside && <OnboardingAside>{aside}</OnboardingAside>}

            <OnboardingContent>
                {loading ? (
                    <LoadingSpinner />
                ) : (
                    <>
                        <h3>Advanced Search</h3>
                        <Input
                            label={"Business Name"}
                            placeholder="Business Name"
                            value={createProps.name}
                            onChange={handleBusinessNameChange}
                            variation="outlined"
                            required={true}
                        />
                        <PlacesAutocomplete
                            variation="outlined"
                            required={true}
                            label={"Business Location"}
                            placeholder="City, State"
                            types={["(cities)"]}
                            onSelect={handleCityStateSelect}
                            onChange={handleCityStateChange}
                            helperText={"Adding a location can help fine-tune your search"}
                        />
                        {/*
                        <div style={{ marginTop: "15px" }}>
                            <SmartDropdown
                                slugLabel={createProps?.template?.name || "Select Business Type"}
                                inputLabel={"Search available types"}
                                options={TEMPLATES}
                                onChange={handleTemplateChange}
                            />
                            <small>
                                If you don't see your business represented, <b>select Everything Else</b>
                            </small>
                        </div>
                        */}
                        <URLInput
                            label={"Website (Optional)"}
                            placeholder="https://"
                            value={createProps?.website}
                            variation="outlined"
                            helperText={"Can be used to find out more information about your business"}
                        />

                        <PrimaryAlternateControl
                            disabled={{ primary: !canSearch }}
                            labels={{ primary: "Search" }}
                            onPrimary={handleNext}
                        />
                    </>
                )}
            </OnboardingContent>
        </>
    );
};
